module.exports = __webpack_public_path__ + "img/53b908a1e712fa045f078e7df4d77fe7.svg";